module.exports = __webpack_public_path__ + "img/home_menu_1_default.bc7a88d4.png";